import Shuffle from 'shufflejs';
import cursor, { cursors } from './cursor';

const blog = {};
export default blog;

let shuffle;

blog.init = (container) => {
  const grid = container.querySelector('[data-shuffle-root]');
  if (grid) {
    if (shuffle) {
      shuffle.destroy();
    }
    shuffle = new Shuffle(grid);
    container.querySelectorAll('a').forEach((el) => {
      el.addEventListener('mouseenter', (e) => {
        cursor.setBgImage(cursors.VIEW);
        cursor.setPosition(e.x, e.y);
        cursor.toggle(true);
      });
      el.addEventListener('mouseleave', () => {
        cursor.toggle(false);
      });
      el.addEventListener('click', () => {
        cursor.toggle(false);
      });
    });
    container.addEventListener('mousemove', e => cursor.setPosition(e.x, e.y));
  }
};

blog.refresh = () => {
  if (shuffle) {
    shuffle.layout();
  }
};
